(() => {
    'use strict';

    const hasUnsavedFilters = widget => {
        const btn = widget.find('.save-filters-btn');
        return btn.length > 0 && !btn.hasClass('d-none');
    }

    const updateResults = (widget, notification) => {
        if (real.events.isFromCurrentUser(notification)) {
            // Our own view is still updated via AJAX.
            howspace.widgets.updateWidget(widget, 'view');
        }
    };

    const renderResults = (widget, notification) => {
        if (hasUnsavedFilters(widget)) {
            // Ignore any broadcasted results when the user is playing with filters.
            console.debug('Priority: Ignoring update due unsaved filters');
            return;
        } else if (real.events.isFromCurrentUser(notification)) {
            // We can ignore our own payload because we're pulling the updated Priority via AJAX.
            return;
        }

        const lister = widget.find('.howspace-lister.average');
        // We'll technically update the lister regardless of whether it is yet visible or not.
        howspace.components.lister.render(lister, notification?.object?.payload);
    };

    howspace.widgets.onEvent('priority:answer:created', (widget, notification) => {
        if (real.events.isFromCurrentUser(notification)) {
            howspace.workspace.page.pathMode.handleUserHasInteracted(widget);
        }
        updateResults(widget, notification);
    });

    howspace.widgets.onEvent('priority:answer:updated', updateResults);

    howspace.widgets.onEvent('priority:answer:deleted', (widget, notification) => {
        if (real.events.isFromCurrentUser(notification)) {
            howspace.workspace.page.pathMode.handleUserHasNotInteracted(widget);
        }
        updateResults(widget, notification);
    });

    howspace.widgets.onEvent('priority:answer:payload', renderResults);

    const deleteAnswer = (widget, successFn) => {
        if (widget.data('answer-id')) {
            real.ajax.json(howspace.widgets.getApiUrl(widget) + '/priorityanswer/' + widget.data('answer-id'), {
                type : 'DELETE',
                success : successFn
            });
        } else {
            successFn();
        }
    };

    const submitAnswer = (widget, successFn) => {
        const dataPayload = {
            selected_options: []
        };

        widget.find('.options-wrapper .priority-option').each(function() {
            dataPayload.selected_options.push($(this).data('id'));
        });

        let url;
        if (widget.data('answer-id')) {
            url = '/priorityanswer/' + widget.data('answer-id');
        } else {
            url = '/priorityanswers';
        }

        real.ajax.json(howspace.widgets.getApiUrl(widget) + url, {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success : successFn,
            logError : response => {
                return response.status !== 409;
            },
            showErrorNotification : response => {
                return response.status !== 409;
            },
            error : response => {
                real.ajax.loopErrors(response, function(error) {
                    if (error.code === 409) {
                        // User has already answered to priority, but UI didn't update fast enough and now
                        // user is trying to answer again and conflict occurred. Just update the
                        // whole widget UI at this point.
                        howspace.widgets.updateWidget(widget, 'view');
                    }
                });
            }
        });
    };

    const setLocalStorage = widget => {
        const optionIds = widget.find('.priority-option').map(function () { return $(this).data('id'); }).get();
        howspace.widgets.setLocalStorage(widget, howspace.widgets.priority.OPTION_IDS, optionIds);
    };

    const getLocalStorage = widget => {
        const optionIds = howspace.widgets.getLocalStorage(widget, howspace.widgets.priority.OPTION_IDS);
        if (optionIds) {
            const optionsWrapper = widget.find('.howspace-sortable-list-items');
            const options = $(optionsWrapper.find('.priority-option-wrapper').toArray().sort(function(a, b) {
                const indexA = $.inArray($(a).find('.priority-option').data('id'), optionIds);
                const indexB = $.inArray($(b).find('.priority-option').data('id'), optionIds);
                return indexA - indexB;
            }));

            options.each(function(index) {
                $(this).find('.index').text(index + 1);
            });

            optionsWrapper.empty().append(options);
        }
    };

    const removeLocalStorage = widget => {
        howspace.widgets.removeLocalStorage(widget, howspace.widgets.priority.OPTION_IDS);
    };

    const toggleListers = (e) => {
        const badge = $(e.target);
        const widget = badge.closest('.widget');
        widget.find('.badge').each(function() {
            $(this).toggleClass('selected');
            $(this).attr('aria-pressed', $(this).hasClass('selected') ? 'true' : 'false');
        });
        widget.find('.howspace-lister').toggleClass('d-none');
    };

    howspace.widgets.priority = {
        OPTION_IDS: 'option-ids',
        initView: widget => {
            // Item moved event.
            widget.on(howspace.components.sortableList.ITEM_MOVED, item => {
                widget.find('.priority-option-wrapper').each(function(index) {
                    const option = $(this);
                    option.find('.index').text(index + 1);

                    setLocalStorage(widget);
                });
            });

            // Show options button.
            widget.find('.show-options-btn').on('click', () => {
                widget.find('.options-wrapper').removeClass('d-none');
                widget.find('.text-wrapper').addClass('d-none');
                widget.find('.results-wrapper').addClass('d-none');
                widget.find('.show-options-btn').prop('disabled', true);
                widget.find('.show-results-btn').prop('disabled', false);
            });

            // Show results button.
            widget.find('.show-results-btn').on('click', () => {
                widget.find('.options-wrapper').addClass('d-none');
                widget.find('.text-wrapper').addClass('d-none');
                widget.find('.results-wrapper').removeClass('d-none');
                widget.find('.show-options-btn').prop('disabled', false);
                widget.find('.show-results-btn').prop('disabled', true);
            });

            // Submit answer.
            widget.find('.submit-btn').on('click', e => {
                const btn = $(e.target);
                real.button.loading(btn, widget);

                submitAnswer(widget, () => {
                    howspace.workspace.page.pathMode.handleUserHasInteracted(widget);

                    removeLocalStorage(widget);
                });
            });

            // Remove answer.
            widget.find('.delete-answer-btn').on('click', e => {
                const btn = $(e.target);
                real.button.loading(btn, widget);

                deleteAnswer(widget, () => {
                    removeLocalStorage(widget);
                });
            });

            // Change answer.
            widget.find('.change-answer-btn').on('click', () => {
                widget.find('.text-wrapper').addClass('d-none');
                widget.find('.results-wrapper').addClass('d-none');
                widget.find('.options-wrapper').removeClass('d-none');
                widget.find('.show-options-btn').prop('disabled', true);
                widget.find('.show-results-btn').prop('disabled', false);

                howspace.components.autosize.update(widget.find('.options-wrapper'));
            });

            // Results rendered event.
            widget.find('.howspace-lister.average').on(howspace.components.lister.LIST_ITEMS_RENDERED, () => {
                const tr = widget.find('.howspace-lister-table tbody tr').first();
                const answerCount = parseInt(tr.data('answer-count'));
                const alert = widget.find('.answer-count-alert');
                if (tr.data('results-notice')) {
                    // An anonymous priority keeps a filtered segment hidden until enough people in it have answered.
                    alert.text(tr.data('results-notice'));
                } else if (answerCount === 1) {
                    alert.text(howspace.translate('priority_answer_count', {'count': answerCount}));
                } else {
                    alert.text(howspace.translate('priority_answers_count', {'count': answerCount}));
                }
            });

            // Legend badges.
            widget.on('click', '.average-badge', toggleListers);
            widget.on('keydown', '.average-badge', (e) => {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    toggleListers(e);
                    return false;
                }
            });

            widget.on('click', '.my-answer-badge', toggleListers);
            widget.on('keydown', '.my-answer-badge', (e) => {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    toggleListers(e);
                    return false;
                }
            });

            getLocalStorage(widget);
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            // Add option button.
            widget.find('.add-option-btn').on('click', () => {
                widget.find('.priority-options').removeClass('d-none');

                const sortableList = widget.find('.howspace-sortable-list');
                howspace.components.sortableList.addItem(sortableList);
            });

            // Add first option.
            if (widget.find('.priority-option').length === 0) {
                widget.find('.add-option-btn').trigger('click');
            }
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            dataPayload.priority_options = [];
            widget.find('.priority-option-wrapper:not(.deleted)').each(function() {
                dataPayload.priority_options.push(real.form.getDataPayload($(this)));
            });
            return dataPayload;
        },
        updateFilter : (widget) => {
            const lister = widget.find('.howspace-lister.average');
            howspace.components.lister.reload(lister);
        }
    };
})();
